/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import './ForChildSwitch.scss';
import { Checkbox } from '../Inputs/Checkbox';

const styles = require('b_')
    .with('for-child-switch');

export const ForChildSwitch = ({
    value,
    label = 'Услуга для ребенка',
    onChange = (_) => {
    },
}) => {
    const [ selectedValue, setSelectedValue ] = useState(value);
    useEffect(() => {
        setSelectedValue(value);
    }, [value]);

    const onChangeHandler = (e) => {
        const v = e?.target.checked;
        setSelectedValue(v);
        onChange(v);
    };

    return (
        <div className={styles()}>
            <Checkbox value={selectedValue} onChange={onChangeHandler} id="forChildSwitch" label={label}/>
        </div>
    );
};
